import { render, staticRenderFns } from "./OwnerInfoSection.vue?vue&type=template&id=491ca6ee&"
import script from "./OwnerInfoSection.vue?vue&type=script&lang=js&"
export * from "./OwnerInfoSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports